import LazyImages from './LazyImages';
import Filter from './Filter';
import Scroll from './Scroll';
import '../../styles/components/_loader.scss';
const SOFT_LOAD_REQUEST_TIMEOUT_MS = 30000;
export default (($) => {
    console.log('UNTUCKit : Module : SoftLoad : loaded');
    const $window = $(window), $loader = $('.js-loader');
    let $collectionTarget = $('[data-ajax-target]');
    function showLoad() {
        $loader.addClass('is-active');
    }
    function hideLoad() {
        $loader.removeClass('is-active');
    }
    const goToURL = function (url) {
        window.location.href = url;
    };
    const scrollToHash = function (hash) {
        const scrollTo = hash === '' ? 0 : $(`#${hash}_h`).offset().top, newUrl = hash === '' ? window.location.href.split('#')[0] : `#${hash}`;
        Scroll.animate(scrollTo);
        if (newUrl) {
            history.replaceState(null, null, newUrl);
        }
    };
    const getCollection = function (url, skipHistory) {
        //fade out container
        const getUrl = `${url}?view=softLoad`;
        $collectionTarget.fadeOut(200, function () {
            showLoad();
            $.ajax({
                url: getUrl,
                timeout: SOFT_LOAD_REQUEST_TIMEOUT_MS,
            })
                .done(function (data) {
                hideLoad();
                $collectionTarget.replaceWith(data);
                Filter.init();
                const title = $('[data-doc-title]').data('doc-title');
                document.title = title;
                finishSuper();
                if (!skipHistory) {
                    if (typeof url !== 'undefined' && url) {
                        history.pushState({ title: title }, title, url);
                    }
                    scrollToHash('');
                }
                LazyImages.update();
            })
                .fail(function (_jqXHR, textStatus) {
                console.log('UNTUCKit : Module : SoftLoad : getCollection failed', textStatus);
                hideLoad();
                goToURL(url);
            });
        });
    };
    const finishSuper = function () {
        LazyImages.update();
    };
    const getInStore = function () {
        const handle = document.body.dataset.collection;
        const getUrl = `/collections/${handle}?view=softloadinstore`;
        console.time("SoftLoad_getInStore");
        $.get(getUrl, function (data) {
            const $other_types = $(".instore_product_types");
            $other_types.replaceWith(data);
            LazyImages.update();
            console.timeEnd("SoftLoad_getInStore");
        }).fail(function () {
            console.log('UNTUCKit : Module : SoftLoad : getInStore Failed');
        });
    };
    const getGrouped = function () {
        const handle = document.body.dataset.collection;
        const getUrl = `/collections/${handle}?view=softloadgroup`;
        console.time("SoftLoad_getGrouped");
        $.get(getUrl, function (data) {
            const $other_types = $(".grouped_products");
            $other_types.replaceWith(data);
            LazyImages.update();
            console.timeEnd("SoftLoad_getGrouped");
        }).fail(function () {
            console.log('UNTUCKit : Module : SoftLoad : getGrouped Failed');
        });
    };
    const bindUIActions = function () {
        window.addEventListener('popstate', function (e) {
            const url = window.location.pathname;
            if (e.state !== null && url.indexOf('collection') !== -1) {
                $collectionTarget = $('[data-ajax-target]');
                getCollection(url, true);
            }
        });
    };
    function inStoreAsync() {
        $window
            .on('load', function () {
            console.log('UNTUCKit : Module : SoftLoad : inStoreAsync');
            getInStore();
        });
    }
    function groupAsync() {
        $window
            .on('load', function () {
            console.log('UNTUCKit : Module : SoftLoad : groupAsync');
            getGrouped();
        });
    }
    function init() {
        console.log('UNTUCKit : Module : SoftLoad : init');
        bindUIActions();
        if (window.groupAsync) {
            groupAsync();
        }
    }
    return { init, inStoreAsync };
})($);
